import strings from "./strings.json";

export default strings;



// WEBPACK FOOTER //
// ./src/static/strings.js